import React, { useEffect } from "react";
import { GridCloseIcon } from "@mui/x-data-grid";
import { MenuItem, TextField } from "@mui/material";
import { useState } from "react";

function MediaCard(props) {
  const {
    media,
    onChange,
    onClick,
    onClose,
    size = "normal",
    enableContext = false,
    courses = [],
  } = props;

  var sizeClass = "h-48 w-80";
  if (size == "small") {
    sizeClass = "h-32 w-52";
  }
  var url;
  const defaultImage = process.env.PUBLIC_URL + "/preview.png";

  if (media.type == "Photo") {
    url = media.url ? media.url : defaultImage;
  } else if (media.type == "Video") {
    url = media.thumbnail ? media.thumbnail : defaultImage;
  } else {
    url = defaultImage;
  }

  return (
    <div className="cursor-pointer">
      <div
        className={
          "relative flex items-end justify-start text-left bg-cover bg-center cusor-pointer rounded " +
          sizeClass
        }
        style={{ backgroundImage: "url(" + url ?? "" + ")" }}
        onClick={onClick}
      >
        <div className="absolute top-0 mt-20 right-0 bottom-0 left-0 bg-gradient-to-b from-transparent to-gray-900 "></div>
        <div className="absolute top-0 right-0 left-0 m-2 flex justify-between items-center">
          <div
            href="#"
            className={
              "text-black  bg-white rounded-full flex gap-1 font-bold opacity-80 " +
              (size == "small" ? "p-1 m-1 text-xsm" : "px-4 py-1 text-xsm")
            }
          >
            <div>{media.type}</div>
            {media.duration && (
              <div>
                {" "}
                •{" "}
                {media.duration < 1
                  ? Math.floor(media.duration * 60 * 100) / 100 + " secs"
                  : Math.floor(media.duration * 100) / 100 + " mins"}{" "}
              </div>
            )}
          </div>
          {onClose && (
            <div
              className="text-white font-regular flex flex-col justify-start"
              onClick={onClose}
            >
              <span className="active:scale-110">
                <GridCloseIcon />
              </span>
            </div>
          )}
        </div>
        <main
          className={
            "flex z-10 text-white w-full " +
            (size == "small" ? " p-1 text-sm " : " p-5 py-3 ")
          }
        >
          <a
            href={media.url}
            className="text-md tracking-tight font-medium leading-7 font-regular  hover:underline flex-grow overflow-ellipsis overflow-hidden whitespace-nowrap"
            target="_blank"
          >
            {media.name ?? "Unnamed"}
          </a>
        </main>
      </div>

      {enableContext && (
        <div>
          <TextField
            type="text"
            size="small"
            fullWidth
            select
            sx={{
              maxWidth: "100%",
            }}
            value={!media.context ? "none" : media.context}
            onChange={(e) => {
              if (e.target.value != "none") {
                onChange({ ...media, context: e.target.value });
              } else {
                onChange({ ...media, context: "" });
              }
            }}
          >
            <MenuItem value="none">Select Course</MenuItem>

            {courses.map((course, index) => {
              return (
                <MenuItem key={index} value={course._id}>
                  {course.name}
                </MenuItem>
              );
            })}
          </TextField>
        </div>
      )}
    </div>
  );
}

export default MediaCard;
